export type NiceSignInFeatureId =
  | 'softphone'
  | 'sapDial'
  | 'contacts'
  | 'transfer'
  | 'acw'
  | 'activityLog';

export const NICE_SIGN_IN_FEATURE_IDS: NiceSignInFeatureId[] = [
  'softphone',
  'sapDial',
  'contacts',
  'transfer',
  'acw',
  'activityLog',
];

export const NICE_SIGN_IN_TIP_IDS = [
  'allowPopups',
  'niceCredentials',
  'staySignedIn',
  'sapCtiAfterLogin',
] as const;
